import { useMutation } from '@tanstack/react-query';
import { putCallDisposition } from 'services/api/putCallDisposition';

export const useUpdateCallDisposition = () => {
    const {
        mutateAsync: updateCallDisposition,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: ({ callId, disposition }: { callId: string; disposition: string }) =>
            putCallDisposition(callId, disposition),
        retry: false,
    });

    return { updateCallDisposition, isPending, ...rest };
};
